var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetStarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1426,
    height: 484,
    viewBox: "0 0 1426 484",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1242.5 401L1324.61 401C1325.51 401 1326.37 400.642 1327.01 400.006C1327.64 399.369 1328 398.506 1328 397.605L1328 375.5C1328 373.015 1330.01 371 1332.5 371H1353.5C1355.99 371 1358 373.015 1358 375.5V396.5C1358 398.985 1355.99 401 1353.5 401H1331.4C1330.49 401 1329.63 401.358 1328.99 401.995C1328.36 402.631 1328 403.495 1328 404.395V426.5C1328 428.985 1325.99 431 1323.5 431H1242.5C1240.01 431 1238 428.985 1238 426.5L1238 405.5C1238 403.015 1240.01 401 1242.5 401Z",
    fill: "url(#paint0_linear_1_37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1272.5 341C1270.01 341 1268 343.015 1268 345.5L1268 366.5C1268 368.985 1270.01 371 1272.5 371L1323.5 371C1325.99 371 1328 368.985 1328 366.5V344.395C1328 343.495 1328.36 342.631 1328.99 341.995C1329.63 341.358 1330.49 341 1331.4 341H1353.5C1355.99 341 1358 338.985 1358 336.5V315.5C1358 313.015 1355.99 311 1353.5 311L1332.5 311C1330.01 311 1328 313.015 1328 315.5V337.605C1328 338.506 1327.64 339.369 1327.01 340.006C1326.37 340.642 1325.51 341 1324.61 341L1272.5 341Z",
    fill: "url(#paint1_linear_1_37)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.901 203.554C222.604 204.257 222.999 205.211 222.999 206.205L222.999 318.251C222.999 320.322 224.678 322.001 226.749 322.001L259.249 322.001C261.32 322.001 262.999 320.322 262.999 318.251L262.999 206.483C262.999 205.489 263.394 204.535 264.097 203.831L264.83 203.099C265.534 202.395 266.487 202 267.482 202L298.796 202C299.79 202 300.744 202.395 301.448 203.098L301.902 203.553C302.605 204.256 303 205.21 303 206.204L303 238.25C303 240.321 304.679 242 306.75 242L339.25 242C341.321 242 343 240.321 343 238.25L343 205.75C343 203.679 341.321 202 339.25 202L307.206 202C306.211 202 305.257 201.605 304.554 200.902L304.098 200.446C303.395 199.743 303 198.789 303 197.794L303 165.75C303 163.679 301.321 162 299.25 162L267.206 162C266.211 162 265.257 161.605 264.554 160.902L264.098 160.446C263.395 159.743 263 158.789 263 157.794L263 125.75C263 123.679 261.321 122 259.25 122L226.75 122C224.679 122 223 123.679 223 125.75L223 158.072C223 159.067 222.605 160.021 221.902 160.724L221.723 160.903C221.02 161.606 220.066 162.001 219.071 162.001L186.749 162.001C184.678 162.001 182.999 163.68 182.999 165.751L182.999 198.073C182.999 199.068 182.604 200.022 181.901 200.725L181.724 200.902C181.02 201.605 180.067 202 179.072 202L146.75 202C144.679 202 143 203.679 143 205.75L143 238.25C143 240.321 144.679 242 146.75 242L179.25 242C181.321 242 183 240.321 183 238.25L183 206.482C183 205.488 183.395 204.534 184.098 203.831L184.83 203.099C185.533 202.396 186.487 202.001 187.481 202.001L218.795 202.001C219.79 202.001 220.743 202.396 221.447 203.099L221.901 203.554ZM224.553 200.903C225.257 201.606 226.21 202.001 227.205 202.001L259.071 202.001C260.066 202.001 261.02 201.606 261.723 200.903L261.902 200.724C262.605 200.021 263 199.067 263 198.072L263 166.204C263 165.21 262.605 164.256 261.902 163.553L261.448 163.099C260.744 162.395 259.79 162 258.796 162L227.482 162C226.487 162 225.534 162.395 224.83 163.099L224.097 163.831C223.394 164.535 222.999 165.489 222.999 166.483L222.999 197.795C222.999 198.79 223.394 199.744 224.097 200.447L224.553 200.903Z",
    fill: "url(#paint2_linear_1_37)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.367 402.715C471.191 403.538 472.307 404 473.472 404H504.61C507.034 404 509 405.966 509 408.391V439.61C509 442.035 507.034 444.001 504.61 444.001L473.055 444.001C471.98 444.001 470.949 444.428 470.189 445.188C469.429 445.948 469.002 446.979 469.002 448.054V479.611C469.002 482.035 467.036 484.001 464.611 484.001H433.392C430.967 484.001 429.001 482.035 429.001 479.611V448.472C429.001 447.308 428.539 446.191 427.715 445.368L427.634 445.287C426.811 444.463 425.694 444.001 424.53 444.001H393.39C390.966 444.001 389 442.035 389 439.61V408.391C389 405.966 390.966 404 393.39 404H424.253C425.417 404 426.534 403.538 427.357 402.715L427.715 402.357C428.539 401.533 429.001 400.417 429.001 399.252V368.39C429.001 365.966 430.967 364 433.392 364H464.611C467.036 364 469.002 365.966 469.002 368.39V399.53C469.002 400.695 469.464 401.811 470.287 402.635L470.367 402.715ZM467.636 405.286C466.812 404.463 465.696 404 464.531 404H433.054C431.979 404 430.948 404.427 430.188 405.188C429.427 405.948 429 406.979 429 408.054V439.531C429 440.695 429.463 441.812 430.286 442.635L430.366 442.715C431.189 443.538 432.306 444.001 433.47 444.001L464.254 444.001C465.418 444.001 466.535 443.538 467.359 442.715L467.714 442.36C468.537 441.536 469 440.42 469 439.255V408.469C469 407.305 468.537 406.188 467.714 405.364L467.636 405.286Z",
    fill: "url(#paint3_linear_1_37)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1212 106.4C1212 109.493 1209.49 112 1206.4 112L1180.27 112C1177.17 112 1174.67 109.493 1174.67 106.4L1174.67 66.028C1174.67 64.5428 1174.08 63.1184 1173.03 62.0682L1172.33 61.3735C1171.28 60.3233 1169.86 59.7333 1168.37 59.7333L1144.55 59.7333C1143.06 59.7333 1141.64 60.3233 1140.59 61.3735L1138.97 62.9863C1137.92 64.0365 1137.33 65.4608 1137.33 66.9461L1137.33 106.4C1137.33 109.493 1134.83 112 1131.73 112L1105.6 112C1102.51 112 1100 109.493 1100 106.4L1100 65.3333C1100 62.2405 1102.51 59.7333 1105.6 59.7333L1132.17 59.7333C1133.54 59.7333 1134.85 59.189 1135.82 58.2201C1136.79 57.2512 1137.33 55.9371 1137.33 54.5668L1137.33 5.6C1137.33 2.5072 1139.84 -3.15419e-06 1142.93 -3.019e-06L1169.07 -1.87668e-06C1172.16 -1.74149e-06 1174.67 2.5072 1174.67 5.6L1174.67 53.4692C1174.67 54.9544 1175.26 56.3788 1176.31 57.429L1176.97 58.0931C1178.02 59.1433 1179.45 59.7333 1180.93 59.7333L1206.4 59.7333C1209.49 59.7333 1212 62.2405 1212 65.3333L1212 106.4Z",
    fill: "url(#paint4_linear_1_37)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M41.1868 342.187C41.947 341.427 42.9781 341 44.0532 341H75.6098C78.0344 341 80 339.034 80 336.609V305.39C80 302.966 78.0344 301 75.6098 301H44.3907C41.966 301 40.0005 302.966 40.0005 305.39V336.251C40.0005 337.416 39.5379 338.533 38.7146 339.356L38.3567 339.714C37.5334 340.537 36.4167 341 35.2523 341H4.39019C1.96556 341 0 342.965 0 345.39V376.609C0 379.034 1.96556 380.999 4.39019 380.999H35.6093C38.034 380.999 39.9995 379.034 39.9995 376.609V345.053C39.9995 343.978 40.4266 342.947 41.1868 342.187Z",
    fill: "url(#paint5_linear_1_37)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1143 297C1146.31 297 1149 299.686 1149 303V331C1149 334.314 1146.31 337 1143 337H1115C1111.69 337 1109 334.314 1109 331L1109 303C1109 299.686 1111.69 297 1115 297L1143 297Z",
    fill: "url(#paint6_linear_1_37)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M870.187 45.8132C869.427 45.053 869 44.0219 869 42.9468L869 11.3902C869 8.96555 867.034 7 864.609 7L833.39 7C830.966 7 829 8.96556 829 11.3902L829 42.6093C829 45.034 830.966 46.9995 833.39 46.9995L864.251 46.9995C865.416 46.9995 866.532 47.4621 867.356 48.2854L867.714 48.6433C868.537 49.4666 869 50.5833 869 51.7476L869 82.6098C869 85.0344 870.965 87 873.39 87L904.609 87C907.034 87 908.999 85.0344 908.999 82.6098L908.999 51.3907C908.999 48.966 907.034 47.0005 904.609 47.0005L873.053 47.0005C871.978 47.0005 870.947 46.5734 870.187 45.8132Z",
    fill: "url(#paint7_linear_1_37)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M407 17C410.314 17 413 19.6863 413 23V51C413 54.3137 410.314 57 407 57H379C375.686 57 373 54.3137 373 51L373 23C373 19.6863 375.686 17 379 17L407 17Z",
    fill: "url(#paint8_linear_1_37)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1387.19 119.187C1387.95 118.427 1388.98 118 1390.05 118H1421.61C1424.03 118 1426 116.034 1426 113.609V82.3902C1426 79.9656 1424.03 78 1421.61 78H1390.39C1387.97 78 1386 79.9656 1386 82.3902V113.251C1386 114.416 1385.54 115.532 1384.71 116.356L1384.36 116.714C1383.53 117.537 1382.42 118 1381.25 118H1350.39C1347.97 118 1346 119.965 1346 122.39V153.609C1346 156.034 1347.97 157.999 1350.39 157.999H1381.61C1384.03 157.999 1386 156.034 1386 153.609V122.053C1386 120.978 1386.43 119.947 1387.19 119.187Z",
    fill: "url(#paint9_linear_1_37)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_37",
    x1: 1298,
    y1: 311,
    x2: 1298,
    y2: 431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_37",
    x1: 1298,
    y1: 311,
    x2: 1298,
    y2: 431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_37",
    x1: 243,
    y1: 322.001,
    x2: 243,
    y2: 122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_37",
    x1: 449,
    y1: 364,
    x2: 449,
    y2: 484.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_37",
    x1: 1212,
    y1: 56,
    x2: 1100,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_37",
    x1: 40,
    y1: 301,
    x2: 40,
    y2: 380.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_37",
    x1: 1129,
    y1: 297,
    x2: 1129,
    y2: 337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_37",
    x1: 829,
    y1: 47,
    x2: 908.999,
    y2: 47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_37",
    x1: 393,
    y1: 17,
    x2: 393,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_37",
    x1: 1386,
    y1: 78,
    x2: 1386,
    y2: 157.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetStarted);
export default __webpack_public_path__ + "static/media/get-started.93533b675fbaf148ef2c453af7e3484d.svg";
export { ForwardRef as ReactComponent };